import React, { useEffect, useRef, useState } from 'react';
import { Toast } from 'azure-devops-ui/Toast';
import { IShowToastEventData, SHOW_TOAST_EVENT, subscribe, unsubscribe } from '../services/appToast.service';

export default function Notification() {
  const [isVisible, setIsVisible] = useState(false);
  const [isFadingOut, setIsFadingOut] = useState(false);
  const [message, setMessage] = useState('');
  const toastRef = useRef<Toast>(null);

  async function hide() {
    console.debug('calling hide', toastRef);
    if (isFadingOut) {
      return;
    }

    setIsFadingOut(true);
    await toastRef.current.fadeOut().promise;
    setIsFadingOut(false);
    setIsVisible(false);
    
  }

  function show(message: string, duration: number) {
    console.debug('calling show', toastRef);
    setIsVisible(true);
    setMessage(message);

    setTimeout(() => hide(), duration);
  }

  function toastListener(event: CustomEvent<IShowToastEventData>) {
    show(event.detail.message, event.detail.duration);
  }

  useEffect(() => {
    subscribe(SHOW_TOAST_EVENT, toastListener);

    return () => {
      unsubscribe(SHOW_TOAST_EVENT, toastListener);
    }
  }, [isVisible, isFadingOut, message]);

  if (!isVisible) return null;

  return (
    <div>
      {isVisible && (
        <Toast
          ref={toastRef}
          message={message}
          callToAction='Dismiss'
          onCallToActionClick={() => toastRef.current.fadeOut()}
        />
      )}
    </div>
  );
}
